import { render, staticRenderFns } from "./YouTubeVoice.vue?vue&type=template&id=ff92ed2e&scoped=true&"
import script from "./YouTubeVoice.vue?vue&type=script&lang=js&"
export * from "./YouTubeVoice.vue?vue&type=script&lang=js&"
import style0 from "./YouTubeVoice.vue?vue&type=style&index=0&id=ff92ed2e&prod&lang=css&"
import style1 from "./YouTubeVoice.vue?vue&type=style&index=1&id=ff92ed2e&prod&scoped=true&lang=css&"
import style2 from "./YouTubeVoice.vue?vue&type=style&index=2&id=ff92ed2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff92ed2e",
  null
  
)

export default component.exports